var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.346,
    height: 21.966,
    viewBox: "0 0 12.346 21.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-speaker-phone",
    "data-name": "Icon material-speaker-phone",
    d: "M28.631,29.493l-8.838-.018a1.945,1.945,0,0,0-1.761,2.088V49.352a1.945,1.945,0,0,0,1.761,2.088h8.823a1.945,1.945,0,0,0,1.761-2.088V31.563A1.906,1.906,0,0,0,28.631,29.493Zm.687,19.168H19.257V31.978H29.318Z",
    transform: "translate(-18.031 -29.475)",
    fill: "#2e117f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.71eceb001380354d3d342f4d1fe9c9fe.svg";
export { ForwardRef as ReactComponent };